<mat-toolbar class="mkt-navbar colorful-mat-toolbar">
  <span class="example-spacer"></span>
  <div class="mkt-navbar-options" fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="end center">
    <button class="nav-button" mat-button routerLink="/ContactAndHelp/Help" routerLinkActive="active-route">
      {{ 'contact-and-help.contact-and-help' | translate }}
    </button>
  </div>
</mat-toolbar>
